require('./desktop_2016_base');

require('../../../../modules/deal/desktop_2016/frontend/sticky_purchase_cluster');

require('../../../../modules/delivery_estimates/frontend/delivery_estimates');

require('../../../../modules/shipping/frontend/free_shipping');

require('../../../../modules/product_reviews/frontend/product_reviews');

require('../../../../modules/inline_variations/frontend/inline_variations');

require('../../../../modules/static_pages/frontend');

require('../../../../modules/goods_warranty/frontend');

require('../../../../node_modules/grpn-card-ui/lib/frontend');

require('../../../../modules/live_chat/frontend/live_chat');

require('../../../../modules/buy_more/frontend/main');

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvY29yZS9mcm9udGVuZC9zY3JpcHRzL2Rlc2t0b3BfMjAxNi9kZXNrdG9wXzIwMTZfZ29vZHMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvY29yZS9mcm9udGVuZC9zY3JpcHRzL2Rlc2t0b3BfMjAxNi9kZXNrdG9wXzIwMTZfZ29vZHMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQUEsQ0FBUSxxQkFBUjs7QUFDQSxPQUFBLENBQVEsd0VBQVI7O0FBQ0EsT0FBQSxDQUFRLG9FQUFSOztBQUNBLE9BQUEsQ0FBUSxxREFBUjs7QUFDQSxPQUFBLENBQVEsOERBQVI7O0FBQ0EsT0FBQSxDQUFRLGtFQUFSOztBQUNBLE9BQUEsQ0FBUSwyQ0FBUjs7QUFDQSxPQUFBLENBQVEsNkNBQVI7O0FBQ0EsT0FBQSxDQUFRLG9EQUFSOztBQUNBLE9BQUEsQ0FBUSxrREFBUjs7QUFDQSxPQUFBLENBQVEsNENBQVIifQ==
